<template>
  <div>
    <v-tooltip v-if="caixa.capacidade.length == 0" top color="error">
      <template v-slot:activator="{ on, attrs }">
        <v-card
          outlined
          rounded="lg"
          v-on="on"
          v-bind="attrs"
          color="grey lighten-4"
        >
          <v-card-text class="font-weight-bold text-center">
            Caixa
            <p class="mb-0">{{ caixa.caixa | VMask("0#") }}</p>
          </v-card-text>
        </v-card>
      </template>
      <span>Caixa não possui capacidade cadastrada</span>
    </v-tooltip>
    <v-dialog max-width="700" v-model="dialog" scrollable v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-card hover outlined rounded="lg" v-on="on" v-bind="attrs">
          <v-card-text class="font-weight-bold text-center">
            Caixa
            <p class="mb-0">{{ caixa.caixa | VMask("0#") }}</p>
          </v-card-text>
        </v-card>
      </template>
      <v-card>
        <v-card-title class="font-weight-bold">
          Caixa {{ caixa.caixa }}
        </v-card-title>
        <v-card-subtitle
          >Capacidade de produtos para esta caixa</v-card-subtitle
        >
        <v-card-text>
          <v-text-field
            v-if="caixa.capacidade.length > 0"
            label="Pesquisar"
            v-model="pesquisa"
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="caixa.capacidade"
            no-data-text="Não há produtos cadastrados para esta caixa"
            no-results-text="Nenhum produto localizado com esta pesquisa"
            :search="pesquisa"
            dense
          ></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog = false"
            rounded
            :block="isMobile()"
            :class="{ secondary: isMobile() }"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    caixa: Object,
  },
  data: () => ({
    dialog: false,
    pesquisa: "",
    headers: [
      { text: "Gp", value: "gp" },
      { text: "Sgp", value: "sgp" },
      { text: "Item", value: "item" },
      { text: "Produto", value: "produto", width: 350 },
      { text: "Emb", value: "embalagem" },
      { text: "Capac. Máx", value: "capacidade" },
    ],
  }),
  methods: {    
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
.card-caixa-desktop {
  min-height: 150px !important;
}
</style>